<template>
  <div class="bdg-file-cell">
    <p class="file-name">{{ file.name }}</p>

    <div
      class="actions flex flex-row items-center"
      :class="{
        'ml-4': $mq !== 'xl',
        'ml-8': $mq === 'xl'
      }"
    >
      <template v-if="$mq === 'sm' || !mdUsesButtons">
        <a class="icon-container" @click="viewClick">
          <i class="far fa-eye fa-fw text-lg text-red" />
        </a>
      </template>
      <template v-else>
        <bdg-button
          class="ghost small mr-2 uppercase"
          @click.native="viewClick"
        >
          View
        </bdg-button>
        <bdg-button
          class="ghost small uppercase"
          @click.native="deleteClick"
          v-if="!hideDeleteButton"
        >
          Delete
        </bdg-button>
      </template>
    </div>
  </div>
</template>

<script>
import BdgButton from "../BdgButton";

export default {
  name: "BdgFileCell",
  components: { BdgButton },
  props: {
    file: [Object, File],
    mdUsesButtons: Boolean,
    hideDeleteButton: Boolean
  },
  methods: {
    viewClick() {
      if (this.file.viewClickAction) {
        this.file.viewClickAction();
      }
      this.$emit("view", this.file);
    },
    deleteClick() {
      if (this.file.deleteClickAction) {
        this.file.deleteClickAction();
      }
      this.$emit("delete", this.file);
    }
  }
};
</script>

<style lang="scss" scoped>
:not(.striped) {
  & > .bdg-file-cell {
    @apply bg-white;
  }
}

.striped {
  & > .bdg-file-cell {
    &:nth-child(odd) {
      @apply bg-lightgray-lightest;
    }

    &:nth-child(even) {
      @apply bg-lightgray-lighter;
    }
  }
}

.bdg-file-cell {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: "name actions";

  @apply border border-lightgray p-4;

  &:not(:first-child) {
    @apply border-t-0;
  }

  .file-name {
    grid-area: name;
    @apply truncate;
  }

  .actions {
    grid-area: actions;
  }
}

.bdg-table {
  .table {
    &.striped,
    &.alternate-striped {
      .body {
        .body-row {
          .table-cell {
            .files-list-cell {
              .bdg-files-list {
                .bdg-file-cell {
                  @apply bg-transparent;

                  @screen sm {
                    max-width: 10rem;
                  }

                  @screen md {
                    max-width: 12rem;
                  }

                  @screen xl {
                    max-width: 15rem;
                  }
                }
              }
            }
          }
        }
      }
    }

    &.alternate-striped {
      .body {
        .body-row {
          &:first-child {
            .table-cell {
              .files-list-cell {
                .bdg-files-list {
                  .bdg-file-cell {
                    &:first-child {
                      @apply border-t-0;
                    }
                    &:last-child {
                      @apply border-b-0;
                    }
                  }
                }
              }
            }
          }

          .table-cell {
            .files-list-cell {
              .bdg-files-list {
                .bdg-file-cell {
                  &:last-child:not(:first-child) {
                    @apply border-b-0;
                  }
                }
              }
            }
          }
        }
      }
    }

    .body {
      .body-row {
        &:not(:first-child) {
          .table-cell {
            .files-list-cell {
              .bdg-files-list {
                .bdg-file-cell {
                  @apply border-t-0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
